exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_from_404-css_3DI {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center\n}\n.container_from_404-css_3DI .error_from_404-css_3i9 {\n  width: 100%;\n  max-width: 320px;\n  padding: 32px;\n  background: #e8e8eb;\n  text-align: center\n}\n.container_from_404-css_3DI .error_from_404-css_3i9 h1 {\n  font-size: 23.6px;\n  font-size: 1.475rem;\n  font-weight: 300;\n  color: #dc501a;\n  display: block;\n  margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container_from_404-css_3DI",
	"error": "error_from_404-css_3i9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/errors/404-not-found/404.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/errors/404-not-found/404.css
// module chunks = 0